function validNumberFromGet(phoneNumber) {
  if (phoneNumber == null || phoneNumber === "") {
    return "";
  }
  const nums = String(phoneNumber).match(/\d+/g);
  return nums ? nums.join("") : "";
}

const showAlert = (string) => {
  const openAlertMessege = document.querySelector(".alertPopUp");

  openAlertMessege.classList.add("moveClass");
  openAlertMessege.innerHTML = `
    <div class="alertContent">
      <p>${string}</p>
    </div>`;
  setTimeout(() => {
    openAlertMessege.classList.remove("moveClass");
    setTimeout(() => {
      openAlertMessege.innerHTML = "";
    }, 2000);
  }, 3000);
};

// Обертка над fetch для обработки ошибок HTTP (4xx, 5xx)
const safeFetch = async (url, options = {}) => {
  const method = (options.method || "GET").toUpperCase();
  const timeoutMs = options.timeoutMs || 12000;
  const retries = options.retries ?? (method === "GET" ? 1 : 0);
  const onRetryStart = typeof options.onRetryStart === "function" ? options.onRetryStart : null;
  let attempt = 0;

  const isRetryableNetworkError = (error) => {
    if (!error) return false;
    if (error.name === "AbortError") return true;
    // TypeError/Failed to fetch и другие сетевые сбои браузера.
    if (error.name === "TypeError") return true;
    if (typeof error.message === "string") {
      const msg = error.message.toLowerCase();
      return msg.includes("network") || msg.includes("fetch") || msg.includes("load failed");
    }
    return false;
  };

  const runRequest = async () => {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), timeoutMs);

    const requestOptions = {
      ...options,
      signal: controller.signal,
    };

    if ("timeoutMs" in requestOptions) {
      delete requestOptions.timeoutMs;
    }
    if ("retries" in requestOptions) {
      delete requestOptions.retries;
    }
    if ("onRetryStart" in requestOptions) {
      delete requestOptions.onRetryStart;
    }

    try {
      const response = await fetch(url, requestOptions);
      if (!response.ok) {
        throw new Error(`HTTP-ошибка: ${response.status} (${response.statusText})`);
      }
      return response;
    } finally {
      clearTimeout(timeoutId);
    }
  };

  try {
      while (attempt <= retries) {
        try {
          return await runRequest();
        } catch (error) {
          const isRetryable = method === "GET" && isRetryableNetworkError(error);
          const isLastAttempt = attempt === retries;
          if (!isRetryable || isLastAttempt) {
            throw error;
          }

          if (onRetryStart) {
            onRetryStart(attempt + 1, error);
          }
          attempt += 1;
        }
      }
  } catch (error) {
    console.error('Ошибка сети:', error.message);
    console.error('Дополнительные детали:', error);
    throw error;
  }
};

const safeFetchJSON = async (url, options = {}) => {
  const response = await safeFetch(url, options);
  return response.json();
};

export { validNumberFromGet, showAlert, safeFetch };
